// extracted by mini-css-extract-plugin
export default {"rating":"mC-z","numberOfStars":"nC-z","count":"oC-z","barGraphSpacing":"pC-z","barGraph":"qC-z"};